import ProfilePhotosDialog from "./ProfilePhotosDialog";

export default ProfilePhotosDialog;
